export default __webpack_public_path__ + "static/media/aim-ftw.635ce89f.png";